import { c as _c } from "react/compiler-runtime";
import { useCouponsList } from '@/api/skippay/couponsList';
import { QueryFilter } from '@/utils/query';
import { slugify } from '@/utils/string';
export function useEshopDetail(eshopApiId) {
  const $ = _c(26);
  let t0;
  let t1;
  let t2;
  if ($[0] !== eshopApiId) {
    let eshopFilter = new QueryFilter();
    if (eshopApiId) {
      eshopFilter = eshopFilter.prop("merchant").eq(eshopApiId);
    }
    t2 = useCouponsList;
    t0 = 4;
    t1 = eshopFilter.toString();
    $[0] = eshopApiId;
    $[1] = t0;
    $[2] = t1;
    $[3] = t2;
  } else {
    t0 = $[1];
    t1 = $[2];
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t0 || $[5] !== t1) {
    t3 = {
      limit: t0,
      filter: t1
    };
    $[4] = t0;
    $[5] = t1;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = !!eshopApiId;
  let t5;
  if ($[7] !== t4) {
    t5 = {
      enabled: t4
    };
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const eshopQuery = t2(t3, t5);
  let category;
  let hasCategory;
  let t6;
  let t7;
  let t8;
  if ($[9] !== eshopQuery.data?.pages?.[0]?.data[0]?.categories?.[0]) {
    let sameCategoryFilter = new QueryFilter();
    category = eshopQuery.data?.pages?.[0]?.data[0]?.categories?.[0];
    if (category && category.id) {
      sameCategoryFilter = sameCategoryFilter.prop("category").eq(category.id);
    }
    hasCategory = !!category;
    t8 = useCouponsList;
    t6 = 4;
    t7 = sameCategoryFilter.toString();
    $[9] = eshopQuery.data?.pages?.[0]?.data[0]?.categories?.[0];
    $[10] = category;
    $[11] = hasCategory;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
  } else {
    category = $[10];
    hasCategory = $[11];
    t6 = $[12];
    t7 = $[13];
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t6 || $[16] !== t7) {
    t9 = {
      limit: t6,
      filter: t7
    };
    $[15] = t6;
    $[16] = t7;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== hasCategory) {
    t10 = {
      enabled: hasCategory
    };
    $[18] = hasCategory;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  const sameCategoryQuery = t8(t9, t10);
  const t11 = hasCategory ? sameCategoryQuery : null;
  let t12;
  if ($[20] !== category?.name) {
    t12 = category?.name ? slugify(category?.name) : null;
    $[20] = category?.name;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== eshopQuery || $[23] !== t11 || $[24] !== t12) {
    t13 = {
      eshopQuery,
      sameCategoryQuery: t11,
      categorySlug: t12
    };
    $[22] = eshopQuery;
    $[23] = t11;
    $[24] = t12;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  return t13;
}